import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
    { label: "PayMe Portal", to: "/portal", id: "portal" },
    { label: "About Us", to: "/about", id: "about" },
    { label: "Superannuation", to: "/superannuation", id: "superannuation" },
    { label: "FAQs", to: "/faqs", id: "faqs" },
    { label: "Contact Us", to: "/contact-us", id: "contact" },
];

const BTN = "inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-base font-semibold text-primary-foreground transition-colors duration-200 hover:bg-primary/90";

function NavItem({ item, className, onClick }) {
    if (item.external) {
        return (
            <a href={item.href} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick} data-testid={`nav-${item.id}-link`}>
                {item.label}
            </a>
        );
    }
    return (
        <NavLink to={item.to} onClick={onClick} data-testid={`nav-${item.id}-link`} className={({ isActive }) => `${className} ${isActive ? "text-primary" : ""}`}>
            {item.label}
        </NavLink>
    );
}

export default function Header({ onQuote }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const close = () => setMenuOpen(false);

    return (
        <header className="sticky top-0 z-50 border-b border-border bg-white" data-testid="site-header">
            <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-6 px-5 md:px-8">
                <Link to="/" aria-label="PayMe home" data-testid="nav-home-link" onClick={close}>
                    <Logo className="h-12" />
                </Link>

                <nav className="hidden items-center gap-6 lg:flex" data-testid="desktop-nav">
                    {NAV.map((n) => (
                        <NavItem key={n.id} item={n} className="text-base font-medium text-foreground transition-colors duration-200 hover:text-primary" />
                    ))}
                </nav>

                <div className="hidden items-center gap-2.5 lg:flex">
                    <button onClick={onQuote} data-testid="nav-quote-btn" className={BTN}>Request a Quote</button>
                    <Link to="/join" data-testid="nav-join-btn" className={BTN}>Join PayMe</Link>
                    <a href="tel:1800082006" data-testid="nav-phone-link" className={BTN}>
                        <Phone size={16} /> 1800 082 006
                    </a>
                </div>

                <button onClick={() => setMenuOpen((v) => !v)} data-testid="mobile-menu-btn" aria-label="Menu" className="flex h-10 w-10 items-center justify-center rounded-lg border border-border lg:hidden">
                    {menuOpen ? <X size={18} /> : <Menu size={18} />}
                </button>
            </div>

            {menuOpen && (
                <nav className="border-t border-border bg-white px-6 pb-6 pt-2 lg:hidden" data-testid="mobile-nav">
                    {NAV.map((n) => (
                        <NavItem key={n.id} item={n} onClick={close} className="block w-full py-3 text-left font-display text-lg font-semibold" />
                    ))}
                    <div className="mt-3 grid gap-2">
                        <button onClick={() => { close(); onQuote(); }} data-testid="mobile-quote-btn" className={BTN}>Request a Quote</button>
                        <Link to="/join" onClick={close} data-testid="mobile-join-btn" className={BTN}>Join PayMe</Link>
                        <a href="tel:1800082006" className={BTN}><Phone size={16} /> 1800 082 006</a>
                    </div>
                </nav>
            )}
        </header>
    );
}
